// istanbul ignore file
import { AccessIssueEntryMethodLabel } from '../types/access-issues-api';

export const AccessIssuesEntryMethodDefinitions: {
    [key: string]: {
        name: string;
        plural: string;
        description: string;
        enhancedOasAccessType: string;
    };
} = {
    [AccessIssueEntryMethodLabel.Appointment]: {
        name: 'Appointment',
        plural: 'Appointments',
        description: 'The occupant must book an appointment to access the property',
        enhancedOasAccessType: 'Appointment',
    },
    [AccessIssueEntryMethodLabel.EnterWithKeyAsEn]: {
        name: 'Entry notification',
        plural: 'Entry notifications',
        description: 'We will access the property using a key and inform the occupants accordingly',
        enhancedOasAccessType: 'Entry Notification',
    },
    [AccessIssueEntryMethodLabel.EnterWithKeyVacant]: {
        name: 'Vacant entry with key',
        plural: 'Vacant entries with key',
        description: 'We will use a key to access the property while the property is vacant',
        enhancedOasAccessType: 'Single Key Pickup',
    },
    [AccessIssueEntryMethodLabel.EnterWithKeyByTenantRequest]: {
        name: 'Tenant requested key entry',
        plural: 'Tenant requested key entries',
        description: 'The tenant has specifically requested entry to the property be made using a key',
        enhancedOasAccessType: 'Single Key Pickup',
    },
};
